export default __webpack_public_path__ + "static/media/0191.fbdbd285.png";